/** Sticky white top navigation for the marketing landing (PhishFence shell). */
import { Link } from 'react-router-dom';
import { Wordmark } from './Section.js';

const ANCHORS = [
  { href: '#features', label: 'Features' },
  { href: '#pricing', label: 'Pricing' },
  { href: '#faq', label: 'FAQ' },
];

export function Nav() {
  return (
    <header className="sticky top-0 z-30 border-b border-slate-200 bg-white">
      <nav className="mx-auto flex h-14 max-w-6xl items-center justify-between px-4 sm:px-6">
        <a href="#top" aria-label="RevBase home">
          <Wordmark />
        </a>
        <div className="hidden items-center gap-6 sm:flex">
          {ANCHORS.map((a) => (
            <a
              key={a.href}
              href={a.href}
              className="text-sm font-medium text-slate-600 transition-colors hover:text-slate-900"
            >
              {a.label}
            </a>
          ))}
          <Link
            to="/login"
            className="inline-flex items-center justify-center gap-2 rounded-lg bg-brand-700 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-brand-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2"
          >
            Sign in
          </Link>
        </div>
        <Link
          to="/login"
          className="text-sm font-semibold text-brand-700 transition-colors hover:text-brand-800 sm:hidden"
        >
          Sign in
        </Link>
      </nav>
    </header>
  );
}
